import * as React from "react";
import { Project } from "../../core/api/models/project";
import { Property } from "../../core/api/models/property";

interface IGeneralInfoTabProps {
  property: Property;
  reload?: () => void;
}

const AmenitiesTab: React.FunctionComponent<IGeneralInfoTabProps> = (props) => {
  return (
    <div className="px-4 pt-3 pb-2 inner-content row">
      <ul className="list--1 icons-outer amenities_toggleitem  px-0">
        {props.property.amenities?.map((up) => (
          <li className=" col-2 pb-3">
            <div className="item-block">
              <figure className="mb-2">
                <img
                  src={up.attrOptionImage}
                  className="icon-security-person"
                  alt={up.attrOptName}
                />{" "}
              </figure>{" "}
              <div className="option-name font-normal font-weight-semibold">
                {up.attrOptName}
              </div>{" "}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AmenitiesTab;
